/**
 * Authentication-related constants
 * Supabase auth event types and states
 * 
 * These constants align with Supabase Auth events
 * See: https://supabase.com/docs/reference/javascript/auth-onauthstatechange
 */

export const AUTH_EVENTS = {
    /** sonarjs/no-hardcoded-passwords: Correcting false positive. PASSWORD_RECOVERY is a supabase event identifier. */
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    PASSWORD_RECOVERY: 'PASSWORD_RECOVERY',
    SIGNED_IN: 'SIGNED_IN',
    SIGNED_OUT: 'SIGNED_OUT',
    TOKEN_REFRESHED: 'TOKEN_REFRESHED',
    USER_UPDATED: 'USER_UPDATED',
    MFA_CHALLENGE_VERIFIED: 'MFA_CHALLENGE_VERIFIED',
} as const

/**
 * Type for auth event values
 */
export type AuthEvent = (typeof AUTH_EVENTS)[keyof typeof AUTH_EVENTS]
